import React from 'react';
import { connect } from 'react-redux';
import EmployeeInfoPres from '../../presentational/EmployeeDetail/EmployeeInfoPres';
import { transformFormValues } from 'src/helpers';
import { withSnackbar } from 'notistack';
import { getEmployeeDetail, updateEmployeeDetails } from '../../state/employeesActions';

class EmployeeInfoContainer extends React.Component {
  state = {
    isEditable: false,
    showCancelEditlModal: false,
    showDeleteModal: false,
    formData: {},
  };

  render() {
    return (
      <EmployeeInfoPres
        employeeId={this.props.match.params.employeeId}
        isLoading={this.props.isLoading}
        onFormChange={this.handleFormChange}
        showCancelEditlModal={this.state.showCancelEditlModal}
        dynamicContent={this.props.dynamicContent}
        onEdit={this.handleEdit}
        onCancel={this.toggleEditModal.bind(null, true)}
        onCancelModal={this.handleCancel}
        onConfirmModal={this.toggleModal.bind(null, false)}
        onSave={this.handleSave}
        isEditable={this.state.isEditable}
        formData={this.state.formData}
      />
    );
  }

  componentDidMount = () => {
    const { employeeId } = this.props.match.params;
    this.props.getEmployeeDetail(employeeId);
  };

  handleFormChange = data => {
    this.setState({
      formData: data,
    });
  };

  handleSave = async () => {
    const { formValues } = this.state.formData;
    const { employeeId } = this.props.match.params;

    const data = {
      entityId: employeeId,
      ...transformFormValues(formValues),
    };

    this.props.updateEmployeeDetails(data).catch(e => this.props.enqueueSnackbar(e.message, { variant: 'error' }));

    this.setState({
      isEditable: false,
    });
  };

  handleEdit = () => {
    this.setState({ isEditable: true });
  };

  toggleModal = status => {
    this.setState({
      showCancelEditlModal: status,
      showDeleteModal: status,
    });
  };

  toggleEditModal = status => {
    this.setState({
      showCancelEditlModal: status,
    });
  };

  handleCancel = () => {
    this.setState({
      showCancelEditlModal: false,
      showDeleteModal: false,
      isEditable: false,
    });
  };
}

const mapStateToProps = state => {
  return {
    isLoading: state.employees.isLoading,
    dynamicContent: state.employees.dynamicContent,
  };
};

const mapDispatchToProps = {
  getEmployeeDetail,
  updateEmployeeDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(EmployeeInfoContainer));
